<template>
  <v-container class="layout-container">
    <v-card class="text-center ma-16 pa-16">
      <ProgressCircular />
      <h2>{{ $t('connection-manager.google-business.process-authorization') }}</h2>
    </v-card>
  </v-container>
</template>

<script>
import ProgressCircular from '@/components/ProgressCircular.vue'

export default {
  components: { ProgressCircular },
  mounted() {
    // bundle.social holds the token; the redirect only signals that OAuth finished.
    const urlParams = new URLSearchParams(window.location.search)
    const error = urlParams.get('error')
    if (error) {
      window.opener?.postMessage(
        {
          googleBusinessConnectionError: {
            error,
            errorDescription: urlParams.get('error_description'),
          },
        },
        '*'
      )
    } else {
      window.opener?.postMessage({ googleBusinessConnected: true }, '*')
    }
    window.close()
  },
}
</script>
